import { Component, Input, Output, EventEmitter } from '@angular/core';
import { environment } from '@environments/environment';
import { IntlService } from '@progress/kendo-angular-intl';
import { BaseInfoComponent } from "./base-info.component";
import { DatasourceService } from '@app/core/services';
import { Router } from '@angular/router';
import * as moment from 'moment'


@Component({
  selector: 'subtotal-info',
  styleUrls: ['./styles/styles-info.css'],
  styles: [`
    .card {
      height: auto;
    }
    .card-details {
      width: 75%;
    }
    .card-status {
      text-align: center;
      padding-bottom: 12px;
    }
    .card-status > div {
      color: white; 
      background-size: contain; 
      padding: 4px; 
      text-align: center; 
    }
    .card-status > img {
      width: 48px;
    }
    .k-block {
      display: flex;
      align-items: center;
      justify-content: center;
      min-height: 80px;
      border-color: transparent;
    }
    .section-title {
      padding-top: 8px;
      padding-bottom: 4px;
    }
    .section-payment {
      background-color: #ecf0f1;
      display: block;
      width: 100% !important;
      padding: 4px 0;
      text-align: center;
      margin-top: 4px;
      min-height: 18px;
    }
    .section-separator {
      background-color: #ecf0f1;
      display: block;
      width: 100% !important;
      margin: 8px 0;
      min-height: 1px;
    }
  `],
  template: `
    <!--{{customer | json}}-->
    <div class="card">
      <div class="card-details">
        
        
        <div class="section-title">
          <label class="k-label">Efectivo:</label> <span class="right">{{ intl.formatNumber(data.efectivo, "c2") }}</span>
        </div>
        <div class="section-title">
          <label class="k-label">Transferencia y tarjeta:</label> <span class="right">{{ intl.formatNumber(data.other, "c2") }}</span>
        </div>

        <div class="section-separator"></div>

        <div class="section-title" style="font-weight: bold; font-size: 18px; ">
          <label class="k-label">Total:</label>  <span class="right">{{ intl.formatNumber(data.total, "c2") }}</span>
        </div>
        
      </div>            
    </div>  
  `,    
})
export class SubtotalInfoComponent extends BaseInfoComponent {

  //Input: id
  @Input() data : any = 0;  

  @Output() complete = new EventEmitter<{dataItem: any}>();


  constructor(public intl: IntlService, public router: Router, protected service: DatasourceService) { 

    super(intl, router)

  }  

}